    <div class="tw:flex tw:flex-col tw:justify-center tw:p-4">
        <div class="tw:w-full tw:text-center tw:text-xl tw:font-semibold tw:text-primary-500">{{ "EDIT_COMMISSION_MODAL.title" | translate }}</div>


        <div class="tw:flex tw:flex-col">
            <div class="tw:flex tw:flex-col tw:items-center tw:justify-between tw:p-4">
                <div class="tw:font-semibold">{{commission.providerName}}</div>
                <div class="tw:text-sm tw:mb-6 tw:text-neutral-500">{{commission.serviceName}}</div>

                <form [formGroup]="form" class="tw:flex tw:items-center tw:justify-center tw:rounded tw:border tw:border-primary-100 tw:bg-primary-50 tw:p-4 tw:w-full tw:mb-2 tw:gap-2">
                    <app-text-input inputType="number"
                        extraClass="tw:w-24 tw:pr-4"
                        [hasMarginB]="false"
                        [hideErrorMessage]="true"
                        [submitAttempted]="submitAttempted()"
                        formControlName="commissionValue" />
                    <app-button
                        size="sm" [type]="form.get('commissionType')?.value === CommissionTypeOptions.PERCENTAGE ? 'primary' : 'secondary'"
                        (clickEvent)="form.patchValue({ commissionType: CommissionTypeOptions.PERCENTAGE })"
                        ><span class="tw:text-primary-500" [class.tw:!text-white]="form.get('commissionType')?.value === CommissionTypeOptions.PERCENTAGE"
                            >%</span
                        ></app-button
                    >
                    <app-button
                        size="sm" [type]="form.get('commissionType')?.value === CommissionTypeOptions.FIXED ? 'primary' : 'secondary'"
                        (clickEvent)="form.patchValue({ commissionType: CommissionTypeOptions.FIXED })"
                        ><span class="tw:text-primary-500" [class.tw:!text-white]="form.get('commissionType')?.value === CommissionTypeOptions.FIXED">{{
                            merchantCurrency
                        }}</span></app-button
                    >
                </form>
            </div>

            <div class="tw:flex tw:justify-center tw:gap-2">
                <app-button size="sm" type="primary" [loading]="saving()" (clickEvent)="save()">
                    {{ "GENERAL.save" | translate }}
                </app-button>
                <app-button size="sm" type="transparent" [disabled]="saving()" (clickEvent)="cancel()">
                    {{ "GENERAL.cancel" | translate }}
                </app-button>
            </div>
        </div>
    </div>